import { defaultStyles, type FileIconProps } from "react-file-icon";

export function formatSize(kb: number): string {
  const units = ["KB", "MB", "GB", "TB", "PB", "EB"];
  let size = kb;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
}

export const fileIconStyles: Record<string, Partial<FileIconProps>> = {
  geojson: { type: "code" },
  ...defaultStyles,
};

export function getFilenameExtension(fileName: string): string | undefined {
  const filenameExtension = fileName.split(".").pop();
  return filenameExtension ? filenameExtension.toLowerCase() : undefined;
}

export function isPreviewAvailable(fileName: string): boolean {
  return fileName.endsWith(".geojson");
}
